/*
Monotype Foundry Platform API
Version 1.0.0

Definition: MapFamilyRequest

Properties:
  submissionId: string (required)
  pimFamilyId: number (required)
*/

var MapFamilyRequest = (function () {
  function validateMapFamilyRequest (arg) {
    // Validate submissionId
    if (!arg.submissionId) {
      throw new Error('MapFamilyRequest.submissionId: Missing property')
    }
    if (arg.submissionId && !(typeof arg.submissionId === 'string')) {
      throw new Error('MapFamilyRequest.submissionId: Wrong type: Got \'' + (typeof arg.submissionId) + '\', but expected: \'string\'')
    }
    // Validate pimFamilyId
    if (!arg.pimFamilyId) {
      throw new Error('MapFamilyRequest.pimFamilyId: Missing property')
    }
    if (arg.pimFamilyId && !(typeof arg.pimFamilyId === 'number')) {
      throw new Error('MapFamilyRequest.pimFamilyId: Wrong type: Got \'' + (typeof arg.pimFamilyId) + '\', but expected: \'number\'')
    }
  }
  function buildMapFamilyRequest (arg) {
    var MapFamilyRequest = arg
    // Complete submissionId
    // Expected Type: string
    MapFamilyRequest.submissionId = MapFamilyRequest.submissionId || ''
    // Complete pimFamilyId
    // Expected Type: number
    MapFamilyRequest.pimFamilyId = MapFamilyRequest.pimFamilyId || 0
    return MapFamilyRequest
  }
  return {
    validate: validateMapFamilyRequest,
    build: buildMapFamilyRequest
  }
})()

module.exports = MapFamilyRequest
